import {PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR} from '../../constants';

export type ClearPanelPropsValidationErrorAction = {
    type : typeof PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR;
}

/**
 * @memberOf! Actions
 *
 * @return {ClearPanelPropsValidationErrorAction}
 */
const clearPanelPropsValidationError = () : ClearPanelPropsValidationErrorAction => {
    return {
        type: PANELMANAGER_CLEAR_PANELPROPS_VALIDATIONERROR
    };
}
export type ClearPanelPropsValidationError = typeof clearPanelPropsValidationError;

export default clearPanelPropsValidationError;
